import * as React from 'react';
import { Edit, EditProps, NumberInput, SelectInput, SimpleForm, TextInput } from 'react-admin';
import { ELanguage } from '../enums';

export const CoachGuideCategoryEdit = (props: EditProps): React.ReactElement => {
	return (
		<Edit {...props} undoable={false}>
			<SimpleForm>
				<NumberInput step={1} source="id" label="#" disabled/>
				<TextInput step={1} source="name" label="NAME"/>
				<SelectInput step={1} source="language" label="LANGUAGE" emptyValue={null} emptyText="" choices={[{id: null, name: ''} , ...Object.keys(ELanguage).map(key => ({
					id: ELanguage[key],
					name: ELanguage[key]
				}))]}/>
			</SimpleForm>
		</Edit>
	);
};
